import types from 'redux/types';

const setAutoRecharge = (data) => {
  return {
    ...data,
    type: types.REQUEST_SET_AUTO_RECHARGE,
  };
};

const getListOfHistoryCharge = () => {
  return {
    type: types.REQUEST_GET_LIST_HISTORY_CHARGE,
  };
};

const getMoreHistoryCharge = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_MORE_HISTORY_CHARGE,
  };
};

const deleteCard = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_CARD,
  };
};

const setDefaultCard = (data) => {
  return {
    ...data,
    type: types.REQUEST_MAKE_DEFAULT,
  };
};

const getListCard = () => {
  return {
    type: types.REQUEST_LIST_CARD,
  };
};

const createCard = (data) => {
  return {
    ...data,
    type: types.REQUEST_ADD_CARD_METHOD,
  };
};

const resetFormCard = () => {
  return {
    type: types.RESET_FORM_CARD,
  };
};

const selectPayment = (data) => {
  return {
    ...data,
    type: types.REQUEST_PAYMENT_SELECTED,
  };
};

const purchaseCredit = (data) => {
  return {
    ...data,
    type: types.REQUEST_PURCHASE,
  };
};

const getListPackage = () => {
  return {
    type: types.REQUEST_LIST_PACKAGE,
  };
};

export default {
  getMoreHistoryCharge,
  getListPackage,
  purchaseCredit,
  setAutoRecharge,
  getListOfHistoryCharge,
  deleteCard,
  setDefaultCard,
  getListCard,
  resetFormCard,
  createCard,
  selectPayment,
};
